import type { TransactionIdCellData } from './types';
import { kind } from './types';

import {
  isCustomCellData,
  getCustomCellTemplate,
  isKindOfCustomCell,
} from '../utils';

const defaultConfig = {
  allowOverlay: false,
  readonly: true,
};

const getDefaultTransactionIdCellData = ({
  value = null,
}: Partial<TransactionIdCellData> = {}): TransactionIdCellData => ({
  kind,
  value,
});

const isCellData = (data: unknown): data is TransactionIdCellData => {
  if (!isCustomCellData(data)) return false;
  return data.kind === kind;
};

type Args = { value?: unknown };

/**
 * ## getCellTemplate
 *
 * @param value The value of the TransactionIdCell
 * @returns A custom TransactionIdCell object and its data
 */
export const getCellTemplate = ({ value = null }: Args = {}) => {
  if (typeof value === 'string' || value === null) {
    const cellData = getDefaultTransactionIdCellData({ value });
    return getCustomCellTemplate({ cellData, ...defaultConfig });
  }
  return getCustomCellTemplate({
    cellData: getDefaultTransactionIdCellData(),
    ...defaultConfig,
  });
};

export const isCell = (
  cell: unknown
): cell is ReturnType<typeof getCellTemplate> => {
  if (typeof cell !== 'object') return false;
  if (cell === null) return false;
  if (isKindOfCustomCell(cell)) {
    return isCellData(cell.data);
  }
  return false;
};
